import React from "react";
import styles from "../../../../styles/AdminConsole.module.css";
import {
  COUNTRIES,
  FABRIC_CATEGORIES,
  TRADE_ROLES,
} from "../../../../data/constants";
import Modal from "../../shared/components/Modal";
import SelectWrapper from "../../shared/components/SelectWrapper";
import ChipInput from "../../shared/components/ChipInput";

/**
 * EditLeadModal
 *
 * Props:
 *   lead            object — the lead being edited (used for title)
 *   form            { buyerName, contactPerson, country, fabricCategory, tradeRole, buyerEmails, meetingDate, meetingLocation }
 *   setForm         (updater) => void
 *   emailInput      string
 *   setEmailInput   (val) => void
 *   saving          bool
 *   onSave          () => void
 *   onClose         () => void
 */
const EditLeadModal = React.memo(function EditLeadModal({
  lead,
  form,
  setForm,
  emailInput,
  setEmailInput,
  saving,
  onSave,
  onClose,
}) {
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const addEmail = () => {
    const v = emailInput.trim().toLowerCase();
    if (!v.includes("@") || form.buyerEmails.includes(v)) return;
    setForm((f) => ({ ...f, buyerEmails: [...f.buyerEmails, v] }));
    setEmailInput("");
  };
  const removeEmail = (e) =>
    setForm((f) => ({
      ...f,
      buyerEmails: f.buyerEmails.filter((x) => x !== e),
    }));

  return (
    <Modal title={`Edit — ${lead.buyerName}`} onClose={onClose}>
      <div className={styles.formInner}>
        <input
          className={styles.input}
          placeholder="Buyer Name"
          value={form.buyerName}
          onChange={(e) => set("buyerName", e.target.value)}
        />
        <input
          className={styles.input}
          placeholder="Contact Person"
          value={form.contactPerson}
          onChange={(e) => set("contactPerson", e.target.value)}
        />

        <SelectWrapper
          value={form.country}
          onChange={(e) => set("country", e.target.value)}
        >
          <option value="">— Country —</option>
          {COUNTRIES.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </SelectWrapper>

        <SelectWrapper
          value={form.fabricCategory}
          onChange={(e) => set("fabricCategory", e.target.value)}
        >
          {FABRIC_CATEGORIES.map((fc) => (
            <option key={fc} value={fc}>
              {fc}
            </option>
          ))}
        </SelectWrapper>

        <SelectWrapper
          value={form.tradeRole}
          onChange={(e) => set("tradeRole", e.target.value)}
        >
          {TRADE_ROLES.map((tr) => (
            <option key={tr} value={tr}>
              {tr}
            </option>
          ))}
        </SelectWrapper>

        <div>
          <span
            className={styles.toggleLabelText}
            style={{ display: "block", marginBottom: 4, fontSize: 10 }}
          >
            Meeting Date
          </span>
          <input
            className={styles.input}
            type="date"
            value={form.meetingDate}
            onChange={(e) => set("meetingDate", e.target.value)}
          />
        </div>

        <input
          className={styles.input}
          placeholder="Meeting Location"
          value={form.meetingLocation}
          onChange={(e) => set("meetingLocation", e.target.value)}
        />

        <div>
          <span
            className={styles.toggleLabelText}
            style={{ display: "block", marginBottom: 6, fontSize: 10 }}
          >
            Buyer Emails
          </span>
          <ChipInput
            items={form.buyerEmails}
            inputValue={emailInput}
            onInputChange={setEmailInput}
            onAdd={addEmail}
            onRemove={removeEmail}
          />
        </div>

        <button
          className={`${styles.btn} ${styles.btnPrimary}`}
          disabled={saving}
          onClick={onSave}
        >
          {saving ? "Saving…" : "Save Changes"}
        </button>
      </div>
    </Modal>
  );
});

export default EditLeadModal;
